import React from "react";
import PropTypes from "prop-types";
import Modal from "../Modal/Modal";


const ModalErrorTwoFactorAuthentication = ({ show, onConfirm }) => (
	<div className="modal-error-two-factor-authentication">
		<Modal
			title={
				<div className="alert-icon">
					<i className="icon-alert icon-alert-custom" />
					<div>Autenticação do email falhou</div>
				</div>
			}
			description={
				<>
					<p><b>Não conseguimos validar sua autenticação, tente novamente o procedimento com a extensão ou manualmente.</b></p>
					<p>Esse procedimento evita entrarmos em contato com você a cada emissão de passagem com suas milhas, sendo assim, agilizando  suas vendas!</p>
					<p><b>É seguro, simples e rápido!</b></p><p>Vamos lá?</p>
				</>
			}
			confirm="Entendi"
			show={show}
			onConfirm={onConfirm}
			fixed={true}
			withoutClose={false}
			width={493}
			height={343}
		/>
	</div>

);

ModalErrorTwoFactorAuthentication.propTypes = {
	show: PropTypes.bool.isRequired,
	onConfirm: PropTypes.func.isRequired
};

export default ModalErrorTwoFactorAuthentication;
